<template>
	<div class="comp-emoji-container">
		<div class="comp-emoji-wrap" id="comp-emoji-wrap">
			<div class="comp-emoji-list">
				<img :src="emoji" :class="{'comp-emoji-img-big': menuType !== 'emoji'}" alt="" v-for="(emoji,key) in emojiList.pics" :key="'emoji-'+key" @click="emojiClick(emoji,key)">
				<span v-if="emojiList.type === 'user'" @click="edit(emojiList)">编辑</span>
			</div>
		</div>
		<div class="comp-emoji-menu">
			<span :class="{'comp-emoji-m-item-active': menuType == val.title}" @click="menuClick(val.title)" v-for="val in orgList" v-if="val.title === 'emoji' || showMore">{{val.title}}</span>
			<span :class="{'comp-emoji-m-item-active': menuType == 'user'}" @click="userEmoji()" v-if="showMore">自定义</span>
		</div>
		<div class="comp-emoji-shadow" v-if="showShadow">
			<div class="comp-emoji-shadow-box">
				<div class="comp-emoji-user-title">
					<span>添加表情</span>
					<span @click="colseE">关闭</span>
				</div>
				<div class="comp-emoji-user-from">
					<input type="text" v-model="input.title" placeholder="表情标题">
				</div>
				<div class="comp-emoji-user-from comp-emoji-user-flex" v-if="input.orgs.length > 0">
					<div class="comp-emoji-user-item" v-for="(emoji,key) in input.orgs">
						<img :src="emoji" alt="">
						<span @click="delE(key)">删除</span>
					</div>
				</div>
				<div class="comp-emoji-user-add">
					<oss-img-uploader uploadDir="images/emoji" maxPic=50 key='emoji-u1' @oss-upload-call="ossUploadCall($event)"></oss-img-uploader>
				</div>
				<div class="comp-emoji-user-from" style="padding-top: 5px;">
					<button @click="save">保存</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Emoji from '../util/emoji.js';
	import OssImgUploader from './uploader/OssImgUploader.vue'
	import {webSave,webGetList} from '../network/web/emoji.js'
	
	export default {
		components:{
			OssImgUploader
		},
		props:{
			showMore:{
				type: Boolean,
				default: false
			}
		},
		data(){
			return{
				orgList: [],
				emojiList:[],
				menuType: '',
				showShadow: false,
				input:{
					id: 0,
					title: '',
					orgs:[],
					pics: []
				}
			}
		},
		methods:{
			// 表情点击操作
			emojiClick(emoji,key){
				let numList = emoji.match(/[0-9]+/g)
				let title = ''
				if(numList.length > 0){
					title = Emoji.get(numList[0])
					if(title.indexOf('[') !== -1){
						title = title.substring(1,title.length-1)
					}
				}
				let data = {
					path: emoji,
					title: title,
					key: key,
					type: this.menuType
				}
				this.$emit('emoji-call',data)
			},
			
			// 菜单切换
			menuClick(val,force){
				if(force === undefined){
					force = false
				}
				if(force === false && this.menuType === val){
					return
				}
				this.menuType = val
				for (let i = 0; i < this.orgList.length; i++) {
					if(val == this.orgList[i].title){
						this.emojiList = this.orgList[i]
						break
					}
				}
				this.$nextTick(()=>{
					document.getElementById("comp-emoji-wrap").scrollTop = 0
				})
			},
			
			// 用户自定义表情
			userEmoji(){
				this.input.id = 0,
				this.input.title = ''
				this.input.orgs = []
				this.input.pics = []
				this.showShadow = true
			},
			
			// 表情编辑
			edit(data){
				this.input.id = data.id,
				this.input.title = data.title
				this.input.orgs = JSON.parse(JSON.stringify(data.pics))
				this.input.pics = []
				this.showShadow = true
			},
			
			// 删除表情
			delE(key){
				this.input.orgs.splice(key,1)
			},
			
			// 上传文件回调
			ossUploadCall(data){
				this.input.pics = data
			},
			
			// 保存自定义表情
			save(){
				let _this = this
				webSave(this.input,data=>{
					_this.getEmoji(_this.menuType,true)
					_this.colseE()
				})
			},
			
			colseE(){
				this.showShadow = false
			},
			
			// 获取表情列表
			getEmoji(show_type,force){
				let e_data = []
				// 获取系统表情
				let types = ['emoji','hello','hello2','hello3','hello4','hello5']
				for (let i = 0; i < types.length; i++) {
					let emoji = Emoji.list(types[i])
					let pics = []
					for (let j = 0; j < emoji.length; j++) {
						pics.push(emoji[j].path)
					}
					let temp = {
						id: 0,
						title : types[i],
						type: 'default',
						pics: pics
					}
					e_data.push(temp)
				}
				let __this = this
				// 获取自定义表情
				webGetList(data=>{
					if(data.code  == 1){
						let c_data = data.data
						for (let i = 0; i < c_data.length; i++) {
							let temp = {
								id: c_data[i].id,
								title : c_data[i].title,
								type: 'user',
								pics: c_data[i].pics
							}
							e_data.push(temp)
						}
					}
					__this.orgList = e_data
					__this.menuClick(show_type,force)
				})
			}
		},
		created() {
			this.getEmoji('emoji',true)
		}
	}
</script>

<style scoped>
	.comp-emoji-container{
		min-width: 200px;
		max-width: 405px;
		height: 100%;
		position: relative;
		background-color: #eeeeee;
		border-radius: 2px;
		box-shadow: 1px 1px 6px 1px #CCCCCC;
	}
	.comp-emoji-container::after{
		display: block;
		content: '';
		width: 14px;
		height: 14px;
		background-color: #eeeeee;
		position: absolute;
		bottom: -7px;
		left: 10px;
		transform: rotateZ(45deg);
	}
	.comp-emoji-container .comp-emoji-wrap{
		position: absolute;
		top: 10px;
		left: 5px;
		right: 0;
		bottom: 30px;
		overflow-x: hidden;
		overflow-y: auto;	
	}
	.comp-emoji-wrap .comp-emoji-list{
		padding-right: 5px;
		height: auto;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.comp-emoji-list img{
		display: block;
		margin: 4px;
		width: 24px;
		height: 24px;
		cursor: pointer;
	}
	.comp-emoji-list .comp-emoji-img-big{
		width: 44px;
		height: 44px;
		border-radius: 2px;
	}
	.comp-emoji-list span{
		display: block;
		width: 44px;
		height: 44px;
		line-height: 44px;
		text-align: center;
		border-radius: 2px;
		cursor: pointer;
		background: #009688;
		color: #FFFFFF;
		margin: 4px;
	}
	.comp-emoji-menu{
		position: absolute;
		width: 100%;
		height: 20px;
		line-height: 20px;
		bottom: 5px;
		padding: 0 10px;
		box-sizing: border-box;
		user-select: none;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.comp-emoji-menu span{
		display: inline-block;
		font-size: 14px;
		margin-right: 10px;
		cursor: pointer;
		color: #666666;
	}
	.comp-emoji-menu span:last-child{
		margin-right: 0;
	}
	.comp-emoji-menu .comp-emoji-m-item-active{
		color: #42B983;
	}
	.comp-emoji-user{
		padding-right: 5px;
		height: auto;
	}
	.comp-emoji-user-o{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.comp-emoji-shadow{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: #0000006b;
		z-index: 9999;
		user-select: none;
	}
	.comp-emoji-shadow-box{
		position: absolute;
		top: 100px;
		left: 320px;
		right: 220px;
		bottom: 100px;
		background: #FFFFFF;
		border-radius: 4px;
		overflow: auto;
	}
	.comp-emoji-user-title{
		background: #CCCCCC;
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}
	.comp-emoji-user-from{
		padding: 15px 15px 0 15px;
		font-size: 14px;
	}
	.comp-emoji-user-from input{
		width: 200px;
		height: 30px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
	}
	.comp-emoji-user-from button{
		width: 120px;
		height: 30px;
		border: unset;
		padding: 0 5px;
		cursor: pointer;
		background-color: #009E94;
		color: #FFFFFF;
	}
	.comp-emoji-user-flex{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		max-height: 280px;
		overflow: auto;
	}
	.comp-emoji-user-item{
		width: 60px;
		height: 60px;
		overflow: hidden;
		margin: 0 10px 10px 0;
		box-sizing: border-box;
		position: relative;
		border-radius: 2px;
		overflow: hidden;
	}
	.comp-emoji-user-item img{
		width: 100%;
		height: 100%;
	}
	.comp-emoji-user-item span{
		display: block;
		width: 100%;
		position: absolute;
		bottom: 0;
		background: red;
		color: #FFFFFF;
		text-align: center;
		cursor: pointer;
		font-size: 12px;
	}
</style>
